function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "how it works"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1313"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1308"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 1049",
  fill: "none",
  d: "M0 0h101v101H0z"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1307"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1964",
  d: "M48 12h1.5a40.5 40.5 0 010 81h-1A40.5 40.5 0 018 52.5C8 30.132 25.632 12 48 12z",
  fill: "#e8f6f4"
})))), /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon awesome-question-circle",
  d: "M69.557 51.779a19.778 19.778 0 11-19.778-19.778 19.777 19.777 0 0119.778 19.778zM50.309 38.538a10.33 10.33 0 00-9.295 5.085.958.958 0 00.217 1.3l2.767 2.1a.957.957 0 001.329-.169c1.425-1.807 2.4-2.855 4.57-2.855 1.629 0 3.644 1.049 3.644 2.628 0 1.194-.986 1.808-2.595 2.71-1.876 1.052-4.359 2.361-4.359 5.635v.319a.957.957 0 00.957.957h4.466a.957.957 0 00.957-.957v-.106c0-2.27 6.634-2.364 6.634-8.507.002-4.629-4.796-8.14-9.292-8.14zm-.53 19.78a3.669 3.669 0 103.669 3.669 3.673 3.673 0 00-3.669-3.669z",
  fill: "#a1dbd3"
}));
var SvgHowItWorks = function SvgHowItWorks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101
  }, props), _ref);
};
export default SvgHowItWorks;